import React, { Component } from 'react';

import PropTypes from 'prop-types';

import NoteBox from 'common/common/NoteBox';
import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import Tappable from 'common/Tappable';
import withContexts from 'common/util/withContexts';

class WidgetDocsWarning extends Component {
  static propTypes = {
    company: PropTypes.object,
    showIntercom: PropTypes.func.isRequired,
  };

  onContactUsTapped = () => {
    const { showIntercom } = this.props;
    showIntercom();
  };

  renderLink() {
    const { company } = this.props;
    if (!company || company.loading) {
      return 'your-company.canny.io';
    }

    const { domains, subdomain } = company;
    return domains[0] ? domains[0] : subdomain + '.canny.io';
  }

  render() {
    return (
      <NoteBox title="Note">
        <div className="text">
          The widget is an advanced feature. For most cases, we recommend using your full Canny site
          instead ({this.renderLink()}).
        </div>
        <div className="text">
          Still unsure which to use?{' '}
          <Tappable onTap={this.onContactUsTapped}>
            <span className="contact">Contact us</span>
          </Tappable>
        </div>
      </NoteBox>
    );
  }
}

export default withContexts({
  company: DevelopersCompanyContext,
  showIntercom: ShowIntercomContext,
})(WidgetDocsWarning);
